import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
    path,
    mergeDeepLeft,
    clone,
 } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import DynamicFormList from '../../common/DynamicFormList';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import '../../css/forms/default-forms.css';
import {
  basic as fields,
  contacts,
  details
} from './fields';
import style from './style';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import { addNewProject } from '../../api/projects';

export class CustomerAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {
        submit: false,
        errors: [],
        fields: fields,
    };
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const processedData = processFields(this.state.fields);
      this.props.saveForm({ data: JSON.stringify(processedData) });
    }
    return false;
  }

  cancel() {
    this.props.redirectToCustomers();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  parseList(arr) {
    if (arr) {
      return arr.map((item) => ({
          value: item,
          label: item,
        })
      );
    }

    return [];
  }

  render() {
    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/customers', icon: 'account_circle', name: 'Customers' },
          { icon: 'add_to_photos', name: 'Customers Add' },
        ]} />
        <div className="card" style={ style.rounded } >
            <div className="card-header">
              <b>Add Customer</b>
            </div>
            <div className="card-block">
                <div className="col" style={{ paddingBottom: '40px' }}>
                    <button className={'btn btn-danger btn-outline pull-right ml-3'} onClick={this.cancel}>
                        <i className="fa fa-remove"></i>
                        <span className="pl-1">Cancel</span>
                    </button>
                    <button className={'btn btn-success btn-outline pull-right'} onClick={this.submit}>
                        <i className="fa fa-check"></i>
                        <span className="pl-1">Save</span>
                    </button>
                </div>

                <form onSubmit={this.submit}>
                  <div className="col-12">
                    <Input
                        field={this.state.fields['username']}
                        onChange={this.changeFormValue}
                    />

                    <ReactSelectWrapper
                      options={this.parseList(path(['terms', 'options'], this.state.fields))}
                      field={this.state.fields['terms']}
                      onChange={this.changeFormValue}
                    />

                    <ReactSelectWrapper
                      options={this.parseList(path(['taxing', 'options'], this.state.fields))}
                      field={this.state.fields['taxing']}
                      onChange={this.changeFormValue}
                    />

                    <DynamicFormList
                      list={this.state.fields['contacts']}
                      onChange={this.changeFormValue}
                      fields={contacts}
                    />

                    <DynamicFormList
                      list={this.state.fields['details']}
                      onChange={this.changeFormValue}
                      fields={details}
                    />
                  </div>
                </form>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToCustomers: () => {
      dispatch(push('/pages/customers'));
    },
    saveForm: (data) => {
      addNewProject(data)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAdd);



// WEBPACK FOOTER //
// ./src/containers/CustomerAdd/index.js